import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from './Logo'; // Import the Logo component
import './Navigation.css';

function Navigation({ onMenuOpenChange }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    onMenuOpenChange?.(isMenuOpen);
  }, [isMenuOpen, onMenuOpenChange]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="nav-menu">
      <div className="nav-header">
        <Logo /> {/* Logo remains visible in all states */}
        <button className="hamburger" onClick={toggleMenu}>
          <span className="hamburger-icon">{isMenuOpen ? '✕' : '☰'}</span>
        </button>
      </div>
      <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
        <li>
          <a href="/" onClick={() => setIsMenuOpen(false)} className="nav-link">Home</a>
        </li>
        <li>
          <NavLink to="/about" onClick={() => setIsMenuOpen(false)} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>About</NavLink>
        </li>
        <li>
          <NavLink to="/contact" onClick={() => setIsMenuOpen(false)} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>Contact Us</NavLink>
        </li>
        <li>
          <a href="https://gurunanakinstitute.ca/donate/" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)} className="nav-link" style={{ color: 'green' }}>Donate</a>
        </li>
      </ul>
    </nav>
  );
}

export default Navigation;
